import React from 'react';
import { Link } from 'react-router-dom';
import css from './PostCard.module.css';

function PostCard({ post }) {
    return (
        <div className={css.card}>
            <div className={css.imgWrapper}>
                <img className={css.img} src={post.img} alt={post.title} />
            </div>
            <div className={css.body}>
                <p className={css.title}>{post.title}</p>
                <Link to={'/post/' + post.id} className={css.readMore}>
                    Batafsil <i className="bi bi-arrow-right"></i>
                </Link>
            </div>
        </div>
    );
}

export default PostCard;